<template>
    <div class="login login-user">
        <HeaderLogo />
        <div class="login__container">
            <div class="login__container-box">
                <FormLogin />
                <FooterButton />
            </div>
        </div>
        <div class="login__verison">
            <span class="login__verison-text"> {{ getTranslatedText('verison') }}: {{ checkVersion() }} </span>
        </div>
    </div>
</template>
<script>
import HeaderLogo from '@/components/login/terminalId/header/header-logo.vue';
import FormLogin from '@/components/login/terminalId/form/form.vue';
import FooterButton from '@/components/login/terminalId/footer/button.vue';
import languageMixins from '@/mixins/language-mixins';
import { isEnvironment } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { HeaderLogo, FormLogin, FooterButton },
    data() {
        return {};
    },
    methods: {
        checkVersion() {
            const environment = isEnvironment();
            return `${this.$store.state.versionApp} (${this.getTranslatedText(environment)})`;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/login.scss';
</style>
